import { DashboardPageConfig } from "./main/dashboard/DashboardPageConfig";
import { Error404PageConfig } from "./errors/404/Error404PageConfig";
import { LoginPageConfig } from "./login/LoginPageConfig";

export const pagesConfig = [
  DashboardPageConfig,
  Error404PageConfig,
  LoginPageConfig,
];
